// extracted by mini-css-extract-plugin
export var csatScore = "_it-5";
export var header = "_it-1";
export var panelWrapper = "_it-2";
export var postPreview = "_it-3";
export var rightContent = "_it-0";
export var wrappingText = "_it-4";